// extracted by mini-css-extract-plugin
export default {"wrapper":"src-modules-core-components-AddToCalendarButton-style__wrapper_e-XjX"};